/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TracksCountResponse
 */
export interface TracksCountResponse {
    /**
     * The total number of tracks matching the filter criteria
     * @type {number}
     * @memberof TracksCountResponse
     */
    data: number;
}

/**
 * Check if a given object implements the TracksCountResponse interface.
 */
export function instanceOfTracksCountResponse(value: object): value is TracksCountResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TracksCountResponseFromJSON(json: any): TracksCountResponse {
    return TracksCountResponseFromJSONTyped(json, false);
}

export function TracksCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TracksCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function TracksCountResponseToJSON(value?: TracksCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

